import $ from 'jquery';
import AccountService from '../_shared/account-service';

/**
 * @desc Load match day card widgets template
 *  */

export default class MatchDayCardWidgets {
  /**
   * @param {string} container
   */
  constructor({ container = '.match-day-card' } = {}) {
    this.$window = $(window);
    this.$containers = $(container);
    this.widgets = this.$containers
      .toArray()
      .map((el) => MatchDayCardWidgets.createWidget($(el)));

    this.init();
  }

  static createWidget($container) {
    const $matchInfoScores = $container.find('[data-match-info-scores]');

    return {
      $container,
      reloadUrl: $container.data('reload-url'),
      $matchInfo: $container.find('[data-match-info]'),
      $matchInfoLabel: $container.find('[data-match-info-label]'),
      $matchStatusLabel: $container.find('[data-match-status-label]'),
      $matchInfoCountdown: $container.find('[data-match-info-countdown]'),
      $matchInfoScores,
      $matchInfoScoresHome: $matchInfoScores.find('[data-match-info-scores-home]'),
      $matchInfoScoresAway: $matchInfoScores.find('[data-match-info-scores-away]'),
      $matchInfoVideo: $container.find('[data-match-info-video]'),
      $matchInfoLink: $container.find('[data-match-info-link]'),
      matchTimezone: $container.data('match-timezone'),
      cityPlusVideoId: $container.data('city-plus-video-id'),
      videoPlayerId: $container.find('[data-match-info-video]').attr('id') || null,
    };
  }

  init() {
    this.isInitialized = true;

    if (this.widgets.length) {
      this.widgets.forEach((widget) => {
        MatchDayCardWidgets.premiumVideo(widget.cityPlusVideoId, widget.videoPlayerId);
      });
      setInterval(() => {
        this.widgets.forEach((widget) => {
          MatchDayCardWidgets.fetchMatchData(widget);
        });
      }, 60000);
    }
  }

  static fetchMatchData(widget) {
    if (!widget.reloadUrl) {
      return;
    }

    fetch(widget.reloadUrl)
      .then((response) => response.json())
      .then((data) => {
        let matchStatus;

        if (data.isInCountdownMode) {
          matchStatus = 'pre-match';

          widget.$matchInfoScores.addClass('hidden');
          widget.$matchInfoCountdown.addClass('show');
          widget.$matchInfo.addClass('--with-countdown');
        } else if (data.isLive || data.isHalfTime) {
          const text = data.isHalfTime ? 'Half time' : `${data.matchMinute}'`;
          const textShort = data.isHalfTime ? 'HT' : `${data.matchMinute}'`;
          matchStatus = 'live';

          widget.$matchInfoLabel.text(textShort);
          widget.$matchStatusLabel.text(text);

          widget.$matchInfoScores.addClass('show');
          widget.$matchInfoCountdown.addClass('hidden');

          widget.$matchInfo.removeClass('--with-countdown');
        } else if (data.isPostMatch) {
          matchStatus = 'full-time';

          widget.$matchInfoLabel.text('FT');
          widget.$matchStatusLabel.text('Full time');
          widget.$matchStatusLabel.addClass('post-match');
          widget.$matchInfoLink.text('Full-time analysis');

          widget.$matchInfoScores.addClass('--finished');
          widget.$matchInfo.removeClass('--with-countdown');
        }

        if (matchStatus === 'live' || matchStatus === 'full-time') {
          widget.$matchInfoScoresHome.text(data.homeTeamScore);
          widget.$matchInfoScoresAway.text(data.awayTeamScore);
        }

        if (data.cityPlusVideoId) {
          MatchDayCardWidgets.premiumVideo(data.cityPlusVideoId, widget.videoPlayerId);
        }
      });
  }

  static async premiumVideo(videoId, videoPlayerId) {
    if (!videoId || !videoPlayerId) {
      return;
    }

    try {
      await AccountService.isAuthenticated();

      let hasSubscription;
      const userData = await AccountService.getUserData();
      if (userData) {
        hasSubscription = await AccountService.isPremiumUser(userData.id);
      }

      if (hasSubscription) {
        try {
          window.videojs.getPlayer(videoPlayerId).ready(function onPlayerReady() {
            const player = this;

            player.catalog.getVideo(videoId, (error, video) => {
              if (error) {
                console.error('An error occured while getting video: ', error);
                return;
              }

              player.catalog.load(video);
            });
          });
        } catch (e) {
          console.error('Error:', e.error, 'Details:', e.details);
        }
      } else {
        console.warn("User doesn't have a subscription!");
      }
    } catch (e) {
      console.error(`An error occurred during validation of user subscription: ${e}`);
    }
  }
}
